module.exports = __webpack_public_path__ + "static/img/h1.13567f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour2/h1.jpg
// module id = ETQJ
// module chunks = 0